import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../store/store';
import { apiUrl } from '../config/api';

interface User {
  _id: string;
  username: string;
  email: string;
  role: string;
  employedSince?: string;
  createdAt?: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
  allUsers: User[];
}

const tokenFromStorage = localStorage.getItem('token');
const userFromStorage = localStorage.getItem('user');

const initialState: AuthState = {
  token: tokenFromStorage || null,
  user: userFromStorage ? JSON.parse(userFromStorage) : null,
  allUsers: [],
};

const BASE_URL = apiUrl('/api');

// 🔹 Benutzerliste laden (für Admin oder Dashboard)
export const fetchAllUsers = createAsyncThunk<User[], void, { state: RootState }>(
  'auth/fetchAllUsers',
  async (_, { getState }) => {
    const token = getState().auth.token;
    const res = await fetch(`${BASE_URL}/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Fehler beim Laden der Nutzer');
    return res.json();
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
      localStorage.setItem('token', action.payload);
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      localStorage.setItem('user', JSON.stringify(action.payload));
    },
    logout: (state) => {
      state.token = null;
      state.user = null;
      state.allUsers = [];
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllUsers.fulfilled, (state, action) => {
      state.allUsers = action.payload;
    });
  },
});

export const { setToken, setUser, logout } = authSlice.actions;
export default authSlice.reducer;
